module.exports = __webpack_public_path__ + "static/img/icon_1.01e7d22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_1.png
// module id = q8WO
// module chunks = 0